import { connect } from 'react-redux';
import { updateLatestAddedUsers } from './user-management-actions';
import AddUserModal from '../../components/user-management/add-users-modal';

const mapDispatchToProps = {
  updateLatestAddedUsers,
};

const mapStateToProps = state => ({
  activeServiceCenter: state.serviceCenter.activeServiceCenter,
  serviceCenters: state.user.serviceCenters,
  roles: state.userManagement.roles,
  deleteSuccess: state.userManagement.deleteSuccess,
  isDeleting: state.userManagement.isDeleting,
  latestAddedUsers: state.userManagement.latestAddedUsers,
  isAdding: state.userManagement.isAdding,
  isUpdating: state.userManagement.isUpdating,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddUserModal);

